import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../main/main.styles';
import { mixinScreen } from '../../styles';

export const SellerRfqStyles = css`
  ${MainStyles}
  :host {
    ${mixinScreen('flex')}

    align-items: center;
    justify-content: center;
    flex-direction: column;

    --neutral-stroke-divider-rest: var(--neutral-fill-stealth-rest);
  }

  .cascade-route-content zero-tabs.basket-tabs::part(end) {
    min-height: 50px;
  }

  .no-padding-card {
    padding: 0;
  }

  .seller-rfq {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;
  }

  .side-card {
    width: 350px;
    height: 100%;
  }

  .grid-card {
    height: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .seller-rfq-button-style {
    margin-left: 5px;
    height: 26px;
  }

  .seller-rfq-button-style-left {
    margin-left: 25px;
    height: 26px;
  }

  zero-tabs#full-tab {
    height: 100%;
  }

  zero-tab-panel {
    height: 100%;
  }

  vppa-modal {
    display: contents;
  }
`;
